"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * If there is no link for one of the map's booking company, then don't add entry.
 * getLink() from mappings/utils usage will handle whether a valid link should be displayed or not.
 * */

var PRIVACY_LINK_MAP = exports.PRIVACY_LINK_MAP = {
    GLOBAL: {
        1: "https://gadventures.com/privacy/",
        3: "https://www.justyou.com/information/privacy-policy",
        4: "https://www.travelsphere.co.uk/information/privacy-policy",
        13: "https://www.trutravels.com/privacy-policy",
        16: "https://www.smithsonianjourneys.org/privacy/"
    },
    GB: {
        3: "https://www.justyou.co.uk/information/privacy-policy"
    }
};

var BOOKING_CONDITIONS_LINK_MAP = exports.BOOKING_CONDITIONS_LINK_MAP = {
    GLOBAL: {
        3: "https://www.justyou.com/information/booking-conditions/",
        4: "https://www.travelsphere.co.uk/information/booking-conditions/"
    },
    GB: {
        3: "https://www.justyou.co.uk/information/booking-conditions/"
    }
};

var TRAVEL_ACKNOWLEDGEMENT_LINK_MAP = exports.TRAVEL_ACKNOWLEDGEMENT_LINK_MAP = {
    GLOBAL: {
        1: ["https://www.gadventures.com/travel-resources/insurance/", "https://www.gadventures.com/about-us/responsible-travel/travel-conduct-policy/"],
        3: ["https://www.justyou.com/information/booking-conditions/"],
        4: ["https://www.travelsphere.co.uk/information/booking-conditions/"],
        13: ["https://www.trutravels.com/code-of-conduct"]
    },
    GB: {
        3: ["https://www.justyou.co.uk/information/booking-conditions/"]
    }
};

var CHECKIN_LINK_MAP = exports.CHECKIN_LINK_MAP = {
    GLOBAL: {
        1: CHECKIN_BASE_URL,
        3: CHECKIN_JUSTYOU_URL,
        4: CHECKIN_TRAVELSPHERE_URL,
        13: CHECKIN_TRUTRAVELS_URL,
        16: CHECKIN_BASE_URL
    },
    GB: {
        3: CHECKIN_JUSTYOU_UK_URL
    }
};


//////////////////
// WEBPACK FOOTER
// ./app/utils/mappings/links.js
// module id = 155
// module chunks = 0